import { NgModule } from '@angular/core';
import { AngularFireAuthGuard, redirectLoggedInTo, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from '@franbase/frontend/shared/ui/layout';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);
const redirectLoggedInToHome = () => redirectLoggedInTo(['/']);

const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('@franbase/frontend/page/login-page').then(mod => mod.LoginPageComponent),
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToHome }
  },
  {
    path: 'signup',
    loadComponent: () => import('@franbase/frontend/page/signup-page').then(mod => mod.SignupPageComponent),
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToHome }
  },
  {
    path: 'submit-franchise',
    loadComponent: () => import('@franbase/frontend/page/submit-franchise-page').then(mod => mod.SubmitFranchisePageComponent),
  },
  {
    path: 'user-verify',
    loadComponent: () => import('@franbase/frontend/page/user-verify-page').then(mod => mod.UserVerifyPageComponent),
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('@franbase/frontend/page/home-page').then(mod => mod.HomePageComponent),
      },
      {
        path: 'franchise',
        pathMatch: 'full',
        redirectTo: ''
      },
      {
        path: 'franchise/:franchise_slug',
        loadComponent: () => import('@franbase/frontend/page/franchise-detail-page').then(mod => mod.FranchiseDetailPageComponent),
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'overview',
          },
          {
            path: 'overview',
            loadComponent: () => import('@franbase/frontend/shared/franchise/franchise-detail/overview-tab').then(mod => mod.OverviewTabComponent)
          },
          {
            path: 'about',
            loadComponent: () => import('@franbase/frontend/shared/franchise/franchise-detail/about-tab').then(mod => mod.AboutTabComponent)
          },
          {
            path: 'people',
            loadComponent: () => import('@franbase/frontend/shared/franchise/franchise-detail/people-tab').then(mod => mod.PeopleTabComponent)
          },
          {
            path: 'location',
            loadComponent: () => import('@franbase/frontend/shared/franchise/franchise-detail/locations-tab').then(mod => mod.LocationsTabComponent)
          },
          {
            path: 'financial',
            loadComponent: () => import('@franbase/frontend/shared/franchise/franchise-detail/financials-tab').then(mod => mod.FinancialsTabComponent)
          },
          {
            path: 'similar',
            loadComponent: () => import('@franbase/frontend/shared/franchise/franchise-detail/similar-tab').then(mod => mod.SimilarTabComponent)
          },
        ]
      },
      {
        path: 'industry/:industry_slug',
        loadComponent: () => import('@franbase/frontend/page/industry-landing-page').then(mod => mod.IndustryLandingPageComponent)
      },
      {
        path: 'industry-listing',
        loadComponent: () => import('@franbase/frontend/page/frachise-by-industry-page').then(mod => mod.FrachiseByIndustryPageComponent),
      },
      {
        path: 'location/:location_slug',
        loadComponent: () => import('@franbase/frontend/page/location-landing-page').then(mod => mod.LocationLandingPageComponent)
      },
      {
        path: 'location-listing',
        loadComponent: () => import('@franbase/frontend/page/frachise-by-location-page').then(mod => mod.FrachiseByLocationPageComponent),
      },
      {
        path: 'investment/:investment_slug',
        loadComponent: () => import('@franbase/frontend/page/investment-landing-page').then(mod => mod.InvestmentLandingPageComponent)
      },
      {
        path: 'investment-listing',
        loadComponent: () => import('@franbase/frontend/page/frachise-by-investment-page').then(mod => mod.FrachiseByInvestmentPageComponent),
      },
      {
        path: 'top-100-franchise',
        loadComponent: () => import('@franbase/frontend/page/top-100-franchise-page').then(mod => mod.Top100FranchisePageComponent),
      },
      {
        path: 'resources',
        loadComponent: () => import('@franbase/frontend/page/blog').then(mod => mod.BlogComponent),
      },
      {
        path: 'resources/:post_slug',
        loadComponent: () => import('@franbase/frontend/page/post-detail-page').then(mod => mod.PostDetailPageComponent),
      },
      {
        path: 'user',
        loadComponent: () => import('@franbase/frontend/page/user-profile-page').then(mod => mod.UserProfilePageComponent),
        canActivate: [AngularFireAuthGuard],
        data: { authGuardPipe: redirectUnauthorizedToLogin },
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'profile',
          },
          {
            path: 'profile',
            loadComponent: () => import('@franbase/frontend/shared/user/user-profile').then(mod => mod.UserProfileComponent)
          },
          {
            path: 'listing',
            loadComponent: () => import('@franbase/frontend/shared/user/user-listing').then(mod => mod.UserListingComponent)
          },
          {
            path: 'notification',
            loadComponent: () => import('@franbase/frontend/shared/user/user-notification').then(mod => mod.UserNotificationComponent)
          },
          {
            path: 'setting',
            loadComponent: () => import('@franbase/frontend/shared/user/user-setting').then(mod => mod.UserSettingComponent)
          }
        ]
      },
      {
        path: 'privacy-policy',
        loadComponent: () => import('@franbase/frontend/page/privacy-policy-page').then(mod => mod.PrivacyPolicyPageComponent),
      },
      {
        path: 'term-conditions',
        loadComponent: () => import('@franbase/frontend/page/term-conditions-page').then(mod => mod.TermConditionsPageComponent),
      },
      {
        path: 'advertise',
        loadComponent: () => import('@franbase/frontend/page/adv-franbase-page').then(mod => mod.AdvFranbasePageComponent),
      },
      {
        path: 'about-us',
        loadComponent: () => import('@franbase/frontend/page/about-us-page').then(mod => mod.AboutUsPageComponent),
      },
      {
        path: 'contact',
        loadComponent: () => import('@franbase/frontend/page/contact-page').then(mod => mod.ContactPageComponent),
      },
      {
        path: 'search-result',
        loadComponent: () => import('@franbase/frontend/page/search-result-page').then(mod => mod.SearchResultPageComponent),
      },
    ]
  },
  {
    path: 'test',
    loadComponent: () => import('@franbase/frontend/shared/ui/test').then(mod => mod.TestComponent),
  },
  {
    path: '404',
    loadComponent: () => import('@franbase/frontend/page/not-found-page').then(mod => mod.NotFoundPageComponent),
  },
  { path: '**', redirectTo: '/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    scrollPositionRestoration: 'enabled',
  })],
  exports: [RouterModule]
})
export class FrontendShellRoutingModule { }
